import {debounce} from '../_functions'

document.addEventListener("DOMContentLoaded", function (dom) {
    const eventList = dom.target.querySelectorAll('.js-event');
    const searchInput = dom.target.querySelector('.js-events-search-input');
    const blogSelect = dom.target.querySelector('.js-blog-select');

    if (eventList.length && searchInput) {
        const filterevents = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            eventList.forEach(event => {
                const title = event.querySelector('.wrapper__title');
                const titleText = title ? title.innerText.toLowerCase() : '';
                const eventBlog = event.dataset.terms;

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                const matchBlog = blogSelect.value === '' || eventBlog == blogSelect.value;

                if (matchSearch && matchBlog) {
                    event.classList.remove('hidden');
                } else {
                    event.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterevents, 300);
        searchInput.addEventListener('input', handleInput);

        blogSelect.addEventListener('change', filterevents);

        filterevents();
    }
});
